import * as Sentry from "@sentry/react"

export function initializeSentry() {
    Sentry.init({
        dsn: "https://5546e1fe0e3d0103d4aa89505a0bd0dc@o4511893482569728.ingest.de.sentry.io/4511893502099536",
        enabled: import.meta.env.PROD,
        environment: import.meta.env.MODE,
        release: __SENTRY_RELEASE__,
        sendDefaultPii: false,
        enableLogs: false,
        integrations: (integrations) =>
            integrations.filter(
                (integration) => integration.name !== "Breadcrumbs" && integration.name !== "BrowserTracing",
            ),
        maxBreadcrumbs: 0,
        beforeSend(event) {
            delete event.request
            delete event.user
            return event
        },
    })
}
